var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-1 rouded-0",attrs:{"color":_vm.color,"tile":""}},[_c('v-card-title',[_c('p',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.title)+" ("+_vm._s(_vm.tasks.length)+") ")])]),_vm._l((_vm.tasks),function(task){return _c('div',{key:task.index},[_c('TaskListCardVue',{attrs:{"task":task}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }